import React from 'react';
import { connect } from 'react-redux';
import { Layout as AntLayout, BackTop } from 'antd';
import classNames from 'classnames';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import Menu from '../Menu/Menu';
import TermsOfUseModal from '../../scenes/Dashboard/components/TermsOfUseModal/TermsOfUseModal';
import IndustryNavigation from '../../scenes/Industry/components/Navigation/Navigation';
import { appThemeSelector } from '../App/AppSelectors';
import './Layout.scss';

const Layout = ({ children, appTheme, showMenu = false, showSearch = false, isHome = false, user }) => (
  <AntLayout className="layout">
    <Header isHome={isHome} theme={appTheme} />
    <AntLayout className={classNames('content', { home: isHome })}>
      {user && !user.is_user_accepted_toc && <TermsOfUseModal accepted={user.is_user_accepted_toc} />}
      {showMenu && <Menu />}
      {showSearch && <IndustryNavigation />}
      {children}
    </AntLayout>
    <Footer theme={appTheme} />
    <BackTop />
  </AntLayout>
);

const mapStateToProps = (state) => ({
  appTheme: appThemeSelector(state),
  user: state.account.user,
});

export default connect(mapStateToProps)(Layout);
